import DocumentsCont from '../../../components/Common/Documents/DocumentsCont'
import History from '../../../components/Common/History'
import BASForm from '../../../components/Finance/BAS/BASForm'
import BASSummary from '../../../components/Finance/BAS/BASSummary'
import style from '../../../components/Sales/style.css'
import CustomSpin from '../../../elements/CustomSpin'
import IconText from '../../../elements/IconText'
import Status from '../../../elements/Status'
import { strVal } from '../../../modules/Utils'
import moment from 'moment'
import React, { Fragment } from 'react'
import { Divider, Icon, Modal, Popconfirm, Row, Tabs } from 'antd'
import FooterButtons from '../../../elements/Buttons/FooterButtons'
import _, { snakeCase } from 'lodash'
import { CSVLink } from 'react-csv'
import { streamUrl } from '../../../variables'
import Authentication from '../../../modules/Authentication'

const auth = new Authentication()

function BASModal (props) {
  const {
    visible,
    modalType,
    submitting,
    submit,
    generating,
    update,
    formRef,
    onCancel,
    removing,
    generatedCSV,
    onGenerateCSV,
    remove,
    generatedDate,
    bas,
    actions,
    handleActions,
    fetchingActions,
    setBas,
  } = props

  const isNew = modalType === 'new'
  const isConfirmed = ['Confirmed'].includes(bas.status)

  const Operations = ({ bas, ...rest }) => {
    let ops = actions
      .filter(a => a.key !== 'update' && a.key !== 'remove')
      .map(a => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
    if (ops.length > 0 && !isConfirmed) {
      ops.push(
        <a
          target={'_blank'}
          href={`${streamUrl}pdf/${bas._id}?access_token=${auth.getAccessToken()}`}>
          <IconText text={'PDF preview'} type={'file-pdf'}/>
        </a>,
      )
    }

    ops.push(
      <CustomSpin spinning={generating}>
        <CSVLink
          filename={`${snakeCase(bas?.company.fn)}-${snakeCase(
            bas?.end ? moment(bas?.end).format('DD MMM YYYY') : '',
          )}`}
          data={generatedCSV}>
          <Icon type="download"/> Download CSV
        </CSVLink>
      </CustomSpin>,
    )

    return (
      <div {...rest}>
        {ops.length > 0
          ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr])
          : []}
      </div>
    )
  }

  return (
    <Modal
      visible={visible}
      title={'Business Activity Statement'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Business Activity Statement'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <CustomSpin spinning={fetchingActions}>
        <h3 className={style.title}>
          {!isNew && (
            <Fragment>
              <Status value={_.capitalize(bas.status)}/>
              <Operations style={{ marginTop: '10px' }} bas={bas} status={strVal(bas, 'status')}/>
            </Fragment>
          )}
        </h3>
      </CustomSpin>
      <Divider/>

      <Row>
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Details" key="form">
            <BASForm ref={formRef} {...props} isNew={isNew}/>
            <BASSummary data={isNew ? generatedDate : bas}/>
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab="Attachments" key="documents">
            <DocumentsCont editable={true} footer={false} category={false} owner={bas}/>
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab="History" key="history">
            <History owner={bas} key={bas._rev} isArray={true}/>
          </Tabs.TabPane>
        </Tabs>
      </Row>
    </Modal>
  )
}

BASModal.propTypes = {}
BASModal.defaultProps = {}

export default BASModal
